/* eslint-disable react/jsx-no-useless-fragment */

import { PropsWithChildren } from 'react';
import {
  FlagProvider,
  IConfig,
  useFlagsStatus,
} from '@unleash/proxy-client-react';

function UnleashContent({ children }: PropsWithChildren) {
  const { flagsReady } = useFlagsStatus();

  if (flagsReady) return <>{children}</>;

  return null;
}

export function UnleashProvider({ children }: PropsWithChildren) {
  const config: IConfig = {
    url: process.env.REACT_APP_UNLEASH_URL ?? '',
    clientKey: process.env.REACT_APP_UNLEASH_CLIENT_KEY ?? '',
    appName: 'app-promo-code',
    disableRefresh: true,
  };

  return (
    <FlagProvider config={config}>
      <UnleashContent>{children}</UnleashContent>
    </FlagProvider>
  );
}
